const routes = [
  {
    path: "/parametros-criacao-cargas",
    name: "parametros-criacao-cargas",
    meta: {
      allowedPermissions: ["parametro_ensino_carga_list"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import("@/views/ParametrosCriacaoCargas/ParametrosCriacaoCargasHome.vue"),
  },

  {
    path: "/parametros-criacao-cargas/novo",
    name: "parametros-criacao-cargas-novo",
    meta: {
      allowedPermissions: ["parametro_ensino_carga_insert"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import("@/views/ParametrosCriacaoCargas/ParametrosCriacaoCargasCad.vue"),
  },

  {
    path: "/parametros-criacao-cargas/editar/:id",
    name: "parametros-criacao-cargas-editar",
    meta: {
      allowedPermissions: ["parametro_ensino_carga_update"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import("@/views/ParametrosCriacaoCargas/ParametrosCriacaoCargasEdit.vue"),
  },
];

export default routes;
